module.exports = __webpack_public_path__ + "img/2x.3d4fccf.jpg";